var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"justify":"center","no-gutters":""}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_vm._v(" "+_vm._s(_vm.format(new Date(), "YYY"))+" "),_c('strong',[_vm._v(_vm._s(_vm.$t("Nomad")))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }